import { Add, Remove } from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material";
import { dimSx } from "../utils/utils";

export const PiecesStepper = ({
	value,
	disabled,
	dim,
	onAdjust,
}: {
	value: number;
	disabled: boolean;
	dim?: boolean;
	onAdjust: (delta: number) => void;
}) => (
	<Stack
		direction="row"
		alignItems="center"
		justifyContent="flex-start"
		gap={1}
	>
		<IconButton
			size="small"
			sx={{ p: 0.25 }}
			disabled={disabled || value <= 0}
			onClick={() => onAdjust(-1)}
		>
			<Remove sx={{ fontSize: 16 }} />
		</IconButton>
		<Box
			component="span"
			sx={{
				minWidth: 24,
				textAlign: "right",
				fontVariantNumeric: "tabular-nums",
				...(dim ? dimSx : {}),
			}}
		>
			{value.toLocaleString()}
		</Box>
		<IconButton
			size="small"
			sx={{ p: 0.25 }}
			disabled={disabled}
			onClick={() => onAdjust(1)}
		>
			<Add sx={{ fontSize: 16 }} />
		</IconButton>
	</Stack>
);
